function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

export { getAltAxis as g };
//# sourceMappingURL=getAltAxis-e2c509e9.js.map
